/** Join existing answer text with newly dictated speech (does not replace existing content). */
export function appendSpeechText(existing: string, addition: string): string {
  const trimmedAddition = addition.trim();
  if (!trimmedAddition) {
    return existing;
  }

  const trimmedExisting = existing.trimEnd();
  if (!trimmedExisting) {
    return trimmedAddition;
  }

  return `${trimmedExisting} ${trimmedAddition}`;
}
